import _arity from './_arity';
import _curry2 from './_curry2';

export default function _createPartialApplicator(concat) {
  return _curry2(function (fn, args) {
    return _arity(Math.max(0, fn.length - args.length), function () {
      return fn.apply(this, concat(args, arguments));
    });
  });
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/ramda/es/internal/_createPartialApplicator.js
// module id = ../node_modules/ramda/es/internal/_createPartialApplicator.js
// module chunks = 5